<template>
  <div class="commutators-chart avoid-break">
    <e-chart
      class="commutators-chart__chart"
      autoresize
      ref="commutatorsChart"
      :options="options"
      @rendered="onRendered"
    />
    <img
      class="commutators-chart__image img-fluid"
      alt="commutators-chart-image"
      :src="chartImg"
    >
    <span class="commutators-chart__period">
      {{ chartData.period | enumFilter('engineering.commutator-maintenance') }}
    </span>
  </div>
</template>

<script>
import enumFilter from '@/filters/enumFilter';
import { formatNumber } from '@/services/translate';
import themeService from '@/services/themeService';
import { mapGetters } from 'vuex';

export default {
  name: 'CommutatorsChart',
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    labelSize: {
      type: Number,
      default: 10,
    },
    isCollapsed: {
      type: Boolean,
    },
  },
  data: () => ({
    chartImg: null,
  }),
  computed: {
    ...mapGetters([
      'isPrinting',
    ]),
    fontColor() {
      return this.isPrinting
        ? themeService.getStyleVar('color-gray-medium-dark')
        : themeService.getFontColor();
    },
    bgColor() {
      return this.isPrinting
        ? themeService.getStyleVar('chart-print-background')
        : themeService.getStyleVar('color-background-dark');
    },
    options() {
      const series = this.getChartSeries();
      return {
        backgroundColor: this.bgColor,
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: this.fontColor,
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: this.fontColor,
            },
          },
          axisLabel: {
            fontSize: this.labelSize,
            color: this.fontColor,
            formatter: value => formatNumber(value,
              { maximumFractionDigits: 0 }),
          },
          splitLine: {
            show: false,
          },
          minInterval: 1,
        },
        grid: {
          top: 20,
          bottom: 30,
          right: 10,
          left: 50,
        },
        color: [
          themeService.getStyleVar('color-gray'),
          themeService.getStyleVar('color-primary'),
          themeService.getStyleVar('color-secondary'),
        ],
        series,
      };
    },
  },
  filters: {
    enumFilter,
  },
  methods: {
    getChartSeries() {
      const series = [];
      const label = {
        show: true,
        position: 'top',
        fontSize: this.labelSize,
        color: this.fontColor,
      };
      const values = (this.chartData || {}).values || [];
      values.forEach((value, index) => {
        if (index !== 1) {
          series.push({
            label,
            data: [value.value],
            type: 'bar',
            zlevel: 0,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1,
            },
          });
          return;
        }
        series.push({
          label,
          data: [value.value],
          barGap: '-10%',
          type: 'bar',
          zlevel: 1,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1,
          },
        });
      });
      return series;
    },
    onRendered() {
      this.$nextTick(() => {
        this.chartImg = this.isCollapsed || !this.$refs.commutatorsChart.height
          ? '#'
          : this.$refs.commutatorsChart.getDataURL();
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .commutators-chart
    display: flex
    justify-content: center
    align-items: flex-end
    &__chart
      border: 1px solid var(--color-border-dark)
      border-radius: 5px
      min-height: 210px
      height: max-content
    &__period
      position: absolute
      margin-bottom: 5px
      font-weight: bold
      font-size: .9em
      white-space: nowrap
    &__image
      display: none
  .manage-fonts_18px
    .commutators-chart__period
      font-size: .75em
  @media print
    .commutators-chart
      &__chart
        display: none
      &__image
        display: inline-block
</style>
